import './Footer.css'
import logo from './images/logo.png'
import Fb from './images/facebook.png'
import Ig from './images/instagram.png'
import Tt from './images/tik-tok.png'
import { Link, useLocation  } from 'react-router-dom';
function Footer(){
    const openLink = (linkType) =>{
        if(linkType === "ig"){
            window.location.href = 'https://www.instagram.com/marinkovic.djordjee/'
        }
        if(linkType === "Tt"){
            window.location.href = 'https://www.tiktok.com/@imarinkovici'
        }
        if(linkType === "Fb"){
            window.location.href = 'https://www.facebook.com/djordjedjole.marinkovic'
        }
    }
    return(
        <div className="Footer">
            <div className='Footer-Content'>

                <div className='Footer-NewsLetter'>
                    
                    <svg version="1.1" id="Layer_1"x="0px" y="0px"viewBox="0 0 128.1 141.7" style={{ enableBackground: "new 0 0 128.1 141.7" }}>
                        <g>
                            <g>
                                <path d="M17,108.5l1.3,13.2h-3.7l-0.7-6.9l-2.2,6.9H8.7l-2.2-6.9l-0.7,6.9H2.1l1.3-13.2h3.8l3.1,7.8l3.1-7.8H17z"/>
                                <path d="M27.8,108.5l5.2,13.2h-3.6l-0.8-2.2h-5.1l-0.8,2.2h-3.8l5.4-13.2H27.8z M24.6,116.7h2.9l-1.4-3.8L24.6,116.7z"/>
                                <path d="M42.5,117.3l3.2,4.4h-4.4l-2.7-4.1h-0.7v4.1h-3.8v-13.2h5.9c1.7,0,2.9,0.4,3.7,1.2c0.8,0.8,1.3,1.9,1.3,3.2
                                    c0,1-0.2,1.9-0.7,2.7C44,116.4,43.3,116.9,42.5,117.3z M39.8,114.5c0.5,0,0.9-0.1,1.2-0.4c0.3-0.2,0.5-0.6,0.5-1.1
                                    c0-0.5-0.2-0.8-0.5-1c-0.3-0.2-0.7-0.4-1.2-0.4h-1.8v2.8H39.8z"/>
                                <path d="M50.9,121.7h-3.8v-13.2h3.8V121.7z"/>
                                <path d="M61.9,108.5h3.8v13.2h-3.8l-5-7.2v7.2h-3.8v-13.2h3.8l5,7.2V108.5z"/>
                                <path d="M75,114.8l5.3,6.9h-4.7l-4.1-5.6v5.6h-3.8v-13.2h3.8v5l3.8-5H80L75,114.8z"/>
                                <path d="M81.8,110.2c1.4-1.3,3.1-2,5.1-2s3.7,0.7,5.1,2c1.4,1.3,2.1,3,2.1,4.9s-0.7,3.5-2.1,4.9c-1.4,1.3-3.1,2-5.1,2
                                    s-3.7-0.7-5.1-2c-1.4-1.3-2.1-3-2.1-4.9S80.4,111.6,81.8,110.2z M84.5,117.6c0.7,0.7,1.5,1,2.4,1c1,0,1.8-0.3,2.4-1
                                    c0.7-0.7,1-1.5,1-2.4c0-1-0.3-1.8-1-2.4c-0.7-0.7-1.5-1-2.4-1c-1,0-1.8,0.3-2.4,1c-0.7,0.7-1,1.5-1,2.4
                                    C83.5,116.1,83.8,116.9,84.5,117.6z"/>
                                <path d="M99,121.7l-5.3-13.2H98l2.8,7.9l2.8-7.9h4.4l-5.3,13.2H99z"/>
                                <path d="M112.8,121.7H109v-13.2h3.8V121.7z"/>
                                <path d="M121.7,118.6c1.2,0,2.2-0.4,3-1.3l1.4,3.2c-0.6,0.5-1.3,0.9-2.1,1.2c-0.8,0.3-1.6,0.4-2.4,0.4c-2,0-3.8-0.7-5.2-2
                                    c-1.4-1.4-2.2-3-2.2-4.9c0-1.9,0.7-3.5,2.2-4.9c1.4-1.4,3.2-2,5.2-2c0.8,0,1.6,0.1,2.4,0.4c0.8,0.3,1.5,0.7,2.1,1.2l-1.4,3.2
                                    c-0.8-0.9-1.8-1.3-3-1.3c-1,0-1.9,0.3-2.6,1c-0.7,0.7-1.1,1.5-1.1,2.4c0,1,0.4,1.8,1.1,2.4C119.8,118.2,120.6,118.6,121.7,118.6z
                                    M119.5,107.3l1.9-3.1h3.8l-3.1,3.1H119.5z"/>
                            </g>
                            <g>
                                <path d="M38.5,127.6c1.5,0,2.6,0.4,3.4,1.1c0.8,0.7,1.1,1.7,1.1,2.9c0,1.1-0.4,2-1.1,2.8c-0.7,0.8-1.7,1.2-2.9,1.2h-2.6v4h-2.3
                                    v-12H38.5z M38.8,133.3c0.6,0,1-0.2,1.4-0.5c0.4-0.3,0.6-0.7,0.6-1.2c0-0.5-0.2-1-0.6-1.3s-0.9-0.4-1.4-0.4h-2.3v3.4H38.8z"/>
                                <path d="M51.9,127.6h2.3v12h-2.3v-4.8h-5.1v4.8h-2.3v-12h2.3v4.8h5.1V127.6z"/>
                                <path d="M63.4,127.6h2.7l-4.3,7.1v4.8h-2.3v-4.8l-4.3-7.1H58l2.7,4.9L63.4,127.6z"/>
                                <path d="M71.3,132.3c0.7,0.1,1.3,0.3,1.8,0.4c0.5,0.2,1,0.4,1.4,0.6c0.4,0.3,0.8,0.6,1,1.1c0.2,0.4,0.3,1,0.3,1.6
                                    c0,1.1-0.4,2-1.3,2.8c-0.8,0.7-2,1.1-3.5,1.1c-1.9,0-3.5-0.7-4.9-2l1.1-2c0.5,0.6,1.1,1,1.8,1.3c0.7,0.3,1.4,0.4,2,0.4
                                    c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.6,0.7-1c0-0.8-0.8-1.3-2.4-1.5c-1.6-0.2-2.8-0.7-3.5-1.3c-0.7-0.6-1-1.4-1-2.3
                                    c0-1,0.4-1.9,1.2-2.7c0.8-0.7,1.9-1.1,3.4-1.1c1.5,0,2.9,0.5,4.1,1.5l-1,2c-0.9-0.8-1.9-1.1-3.2-1.1c-0.7,0-1.2,0.1-1.6,0.3
                                    c-0.4,0.2-0.6,0.5-0.6,1c0,0.4,0.2,0.7,0.5,0.9C69.7,132,70.3,132.1,71.3,132.3z"/>
                                <path d="M79.8,139.5h-2.3v-12h2.3V139.5z"/>
                                <path d="M83.2,129.1c1.2-1.2,2.7-1.8,4.4-1.8c1.7,0,3.2,0.6,4.4,1.8c1.2,1.2,1.8,2.7,1.8,4.4c0,1.7-0.6,3.2-1.8,4.4
                                    c-1.2,1.2-2.7,1.8-4.4,1.8c-1.7,0-3.2-0.6-4.4-1.8c-1.2-1.2-1.8-2.7-1.8-4.4C81.4,131.8,82,130.3,83.2,129.1z M84.8,136.4
                                    c0.8,0.8,1.7,1.2,2.8,1.2c1.1,0,2-0.4,2.8-1.2c0.8-0.8,1.2-1.7,1.2-2.8c0-1.1-0.4-2-1.2-2.8c-0.8-0.8-1.7-1.2-2.8-1.2
                                    c-1.1,0-2,0.4-2.8,1.2c-0.8,0.8-1.2,1.7-1.2,2.8C83.6,134.7,84,135.6,84.8,136.4z"/>
                            </g>
                            <path d="M123,28.8L105.2,39c2.9-3.9,4.6-8.6,4.6-13.8c0-12.9-10.4-23.3-23.3-23.3c-9,0-16.8,5.1-20.7,12.6c0-0.2-0.1-0.4-0.1-0.6
                                c-13.9,2-13.7,2.3-19.5,11.8c-2.7,4.8,0.4,14.2-2.4,18.7c-6.2,4.2-7.4,17.6-11.8,23c-5.4,3.6-4.6,12.1-8.4,16.4
                                c-0.2,1.1-0.1,1.9,0.1,2.4l-17.5,10c-0.7,0.4-0.4,1.6,0.4,1.6l91.2-0.5c0.3,0,0.6-0.2,0.8-0.5l25.6-66.7
                                C124.4,29.1,123.6,28.4,123,28.8z M88.9,48.4L48.5,71.7c-6.7-8.2,7.3,0.6,14-12.6c-0.2-2.1-3.1-6.5-7.3-8.2
                                c-4.8-1.2,1.3-7.6,1.9-10c5,13.1,9.5,4.4,17.1,7.4c2.4,0.9,4.6,0.4,5.9-0.6c2,0.6,4.1,0.9,6.3,0.9C87.3,48.5,88.1,48.5,88.9,48.4z
                                M74,44.9c-0.6,0.1-1.3,0.2-2,0.4c-2.5,0.1-5.7-1.1-8.2-1.1c-0.2-1.4-0.2-3.3-1.3-4.4c-0.8-1.5,0.6-4.8-0.8-6.2
                                c-1.2-1.3-2.7-1.2-2.4-2.4c1.2-1,3.2-1.4,4.2-2.3C64.5,35.6,68.5,41.4,74,44.9z M54.6,20.6c1.8-0.6,7.9-2,10.2-4.2
                                c-0.7,1.7-1.2,3.6-1.5,5.5c-2.2-1.7-7.9,0.7-9.4,4.2C50,26.3,54.1,22.4,54.6,20.6z M28.5,80.2c0.5-1.9,3.7-4.8,5.1-6
                                C35.8,69.1,41.1,62,45,58c3.9-1.5,6.3,1.4,10.4,1.5c-3.5,0.2-5.6,3-8.1,4.8c-1.4,1.9-6.3,1.7-5.6,4.2c0.9,0.3,2.5,2.1,4.4,4.5
                                l-15.8,9.1C28.8,82.1,27.6,81.8,28.5,80.2z"/>
                        </g>
                    </svg>
                    
                    <p>
                        Pretplati se na novosti i ostani u toku!
                    </p>
                    <div className='Newsletter-Button-Wrap'>
                        <input type='email' name='email' placeholder='Unesi svoj mail'>
                        </input>
                        <button>
                            Pretplati se
                        </button>
                    </div>
                </div>
                <div className='Footer-Navigation'>
                    <h1>
                        Stranice
                    </h1>
                    <li>
                        <Link>
                            Services
                        </Link>
                    </li>
                    <li>
                        <Link>
                            About me
                        </Link>
                    </li>
                    <li>
                        <Link>
                            Blog
                        </Link>
                    </li>
                    <li>
                        <Link>
                            Home
                        </Link>
                    </li>
                </div>
                <div className='Footer-Services'>
                    <h1>
                        Services
                    </h1>
                    <li>
                        <Link>
                            Online coaching
                        </Link>
                    </li>
                    <li>
                        <Link>
                            Plans
                        </Link>
                    </li>
                    <li>
                        <Link>
                            Rehab
                        </Link>
                    </li>
                    <li>
                        <Link>
                            Diet
                        </Link>
                    </li>
                </div>
                <div className='Footer-Socials'>
                    <h1>
                        Follow me
                    </h1>
                    <li>
                        <img src={Ig}></img>Instagram
                    </li>
                    <li>
                    <img src={Tt}></img>Tik Tok
                    </li>
                    <li>
                    <img src={Fb}></img>Facebook
                    </li>
                </div>
                
            </div>
            <div className='Footer-Copyright'>
                <div className='Developer'>
                    <p>
                        Made by Bogdan Petrović
                    </p>
                </div>
                <div className='Copy-Right'>
                    <p>
                        &copy; 2024 Đorđe Marinković. All Rights Reserved.
                    </p>
                </div>
            </div>
        </div>
    )
}
export default Footer